import { render, staticRenderFns } from "./AmbassadorConfirm.vue?vue&type=template&id=4ca13c32&"
import script from "./AmbassadorConfirm.vue?vue&type=script&lang=js&"
export * from "./AmbassadorConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports